export default __webpack_public_path__ + "static/media/20.6b642fc8.png";